import React, { FC } from 'react';

import { Box, Typography } from '@mui/material';

import {
  ILongTermContractModel,
  PharmacistLegendVariant,
} from '@pharmaplan/common';

import getLongTermContractLabels from '../../../../common/LongTermContractLabels/LongTermContractLabels';
import PharmacyInfoCard from '../../../../common/PharmacyInfoCard';
import ThemeConstants from '../../../../../theme/ThemeConstants';
import useSelfService from '../../../../../hooks/useSelfService';
import WithSkeleton from '../../../../common/WithSkeleton';
import StackedBox from '../../../../common/StackedBox';
import useAdmin from '../../../../../hooks/useAdmin';
import strings from '../../../../../localization';
import ServiceCard from '../../../ServiceCard';

import styles from './styles';

interface IRequestContractDetailsCard {
  event: {
    longTermShiftContract?: ILongTermContractModel;
    favorite?: boolean;
    logoImage: string;
    pharmacyName: string;
    startDate: string;
    city?: string;
    softwareName: string;
  };
  successAction: string;
  isBooked?: boolean;
}

const RequestContractDetailsCard: FC<IRequestContractDetailsCard> = ({
  event,
  isBooked,
  successAction,
}) => {
  const { isSelfService } = useSelfService();
  const { isAdmin } = useAdmin();

  const {
    longTermShiftContract,
    favorite,
    logoImage,
    pharmacyName,
    startDate,
    softwareName,
    city = '',
  } = event ?? {};
  const {
    startDate: contractStart,
    endDate: contractEnd,
    longTermShiftContractId,
  } = longTermShiftContract ?? {};

  const SkeletonTypography = WithSkeleton({ successAction, variant: 'text' })(
    Typography,
  );

  const { ShiftLabel } = getLongTermContractLabels({
    successAction,
    contractEndDate: contractEnd,
    contractStartDate: contractStart,
    isLongTerm: !!longTermShiftContractId,
  });

  return (
    <StackedBox
      showStacks
      backgroundColor={
        isBooked
          ? ThemeConstants.stackedChips.bookedChip
          : ThemeConstants.stackedChips.postedChip
      }
    >
      <ServiceCard
        customContainerStyle={{ mb: 0, pt: '10px', pr: '10px' }}
        eventType={
          isBooked
            ? PharmacistLegendVariant.booked
            : PharmacistLegendVariant.workshift
        }
        content={(
          <Box sx={styles.cardContainer}>
            <ShiftLabel />
            <Box sx={{ display: 'flex', my: 1 }}>
              <PharmacyInfoCard
                favorite={!!favorite}
                successAction={successAction}
                logoImage={logoImage}
                title={
                  isSelfService || isAdmin || isBooked ? pharmacyName : city
                }
                date={startDate}
                longTermAttributes={{
                  contractEnd,
                  contractStart,
                  longTermShiftContractId,
                }}
              />
            </Box>
          </Box>
        )}
        footer={(
          <Box sx={styles.footerContainer}>
            <SkeletonTypography sx={styles.footerLabel}>
              {strings.software}
            </SkeletonTypography>
            <SkeletonTypography sx={styles.footerValue}>
              {softwareName}
            </SkeletonTypography>
          </Box>
        )}
      />
    </StackedBox>
  );
};

export default RequestContractDetailsCard;
